<div class="vl-page">
  <anb-modal-loading [loaderCounter]="loadingService.loaderCounter"></anb-modal-loading>

  <anb-burgerprofiel-header
    [anbEnvironment]="anbEnvironment"
    [hasAuthenticatedSession]="hasAuthenticatedSession"
    [loginUrl]="loginUrl"
    [version]="2"
    [logoutUrl]="logoutUrl"
    (onLogout)="logout()"
  >
  </anb-burgerprofiel-header>
  <!-- Dashboard -->
  <anb-environment-indicator [anbEnvironment]="anbEnvironment"></anb-environment-indicator>
  <section id="main">
    <anb-alert></anb-alert>

    <div *ngIf="browserSupported">
      <router-outlet></router-outlet>
    </div>

    <div *ngIf="!browserSupported" class="vl-layout vl-layout--wide">
      <div class="vl-alert vl-alert--warning" style="margin: 1.5rem 0rem">
        <div class="vl-alert__icon" aria-hidden="true"></div>
        <div class="vl-alert__content">
          <div class="vl-alert__title">Browser niet ondersteund</div>
          <div class="vl-alert__message">
            <p>Je gebruikt een browser die niet ondersteund is. Gebruik één van de volgende browsers: Chrome, Edge of Firefox.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <anb-burgerprofiel-footer [anbEnvironment]="anbEnvironment"></anb-burgerprofiel-footer>
</div>
